import { DateField, NumberField, ShowContextProvider, ShowView, TextField, useShowController } from 'react-admin';
import ContextTitle from '../../Components/ContextTitle';

const BusinessRuleShow = () => {
  const controllerProps = useShowController();

  return (
    <ShowContextProvider value={controllerProps}>
      <ShowView title={<ContextTitle context="businessRuleType.name" />}>
        <TextField source="id" />
        <TextField source="businessRuleType.name" />
        <TextField source="rulableType" />
        <NumberField source="rulableId" />
        <TextField source="value" />
        <DateField source="createdAt" />
        <DateField source="updatedAt" />
      </ShowView>
    </ShowContextProvider>
  );
};

export default BusinessRuleShow;
